import React, { Component } from 'react';
import { toast } from 'react-toastify';

import BaseModal from '../BaseModal';
import Spinner from 'components/Spinner';
import { fetchQuickSubUsage } from 'api';
import QuickUsageInfo from './QuickUsageInfo';

import styles from './styles.module.scss';

class QuickUsageModal extends Component {
  state = {
    usageData: null,
    loading: false,
  };

  componentDidUpdate(prevProps, prevState) {
    if (!prevProps.isOpen && this.props.isOpen) {
      this.fetchUsage();
    }
  }

  fetchUsage = () => {
    const { sub } = this.props;
    this.setState({ loading: true, usageData: null });
    fetchQuickSubUsage(sub.id)
      .then((res) => {
        this.setState({ usageData: res.data, loading: false });
      })
      .catch((e) => {
        this.setState({ loading: false });
        toast.error('Failed to load usage details');
      });
  };

  render() {
    const { isOpen, closeModal } = this.props;
    const { loading, usageData } = this.state;

    return (
      <BaseModal
        title="Usage Details"
        confirmBtnText=""
        cancelBtnText=""
        onClose={closeModal}
        isOpen={isOpen}
        className={styles.modal}
        contentClassName={styles.content}
      >
        <div className={styles.wrapper}>
          <QuickUsageInfo title="Data" data={usageData?.data} />
          <QuickUsageInfo title="Voice" data={usageData?.voice} />
          <QuickUsageInfo title="Text" data={usageData?.text} />
        </div>
        <Spinner showLoader={loading} />
      </BaseModal>
    );
  }
}

export default QuickUsageModal;
